module.exports = __webpack_public_path__ + "img/logos.dae9a5b5.png";